var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8326 23C12.9759 23 8.85735 21.5828 5.63719 18.3628C2.42239 15.1479 1 11.0322 1 7.16743C1 3.76134 3.75567 1 7.16743 1C7.431 1 7.66798 1.16045 7.76586 1.40515L10.5273 8.30881C10.6595 8.63933 10.4988 9.0144 10.1683 9.14662L7.13486 10.36C7.34945 13.8498 10.1508 16.6509 13.64 16.8652L14.8534 13.8318C14.9853 13.5018 15.3603 13.3405 15.6912 13.4727L22.5948 16.2341C22.8395 16.332 23 16.569 23 16.8326C23 20.2387 20.2443 23 16.8326 23Z",
    fill: "url(#paint0_linear_1092_3781)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1092_3781",
    x1: 1.30711,
    y1: 18.6,
    x2: 23,
    y2: 18.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIc);
export default __webpack_public_path__ + "static/media/phone_ic.e73a70b8ef94878c1ee741bb35b42df5.svg";
export { ForwardRef as ReactComponent };